export default "__VITE_ASSET__Bqt7f5jv__"